import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Globals } from '../models/globals.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MLService {

  apiUri: string;
  graphUri: string;
  componentResourceUri: string;

  getBusinessFunctionTypesApi = "api/ModelManagement/GetBusinessFunctionTypes";
  getComponentListApi = "api/Component/ListComponent";
  getModelParametersApi = "api/GetModelParameter";
  getComponentConnectorApi = 'api/Component/GetComponentConnector';
  saveCustomtComponentApi = 'api/Component/SaveComponentMasterData';
  saveConfigureModelApi = "api/SaveModelConfigureData";
  getAuthDetails = "api/Component/GetAuthDetails";
  getAllSecrets = "api/Component/GetAllSecrets";

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient, public router: Router) {
    this.apiUri = this.globals.config.modelManagementApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
    this.componentResourceUri = this.globals.config.platformHubApi_client_resourceUri;
  }

  getConfigParameter(name, version) {
    return this.http.get(this.apiUri + this.getModelParametersApi + "/" + name + "/" + version);
  }

  getComponentList() {
    return this.http.get(this.componentResourceUri + this.getComponentListApi);
  }

  getAllSecretsList() {
    return this.http.get(this.componentResourceUri + this.getAllSecrets);
  }

  getComponentConnector() {
    return this.http.get(this.componentResourceUri + this.getComponentConnectorApi);
  }

  saveCustomComponent(customComponentData) {
    return this.http.post(this.componentResourceUri + this.saveCustomtComponentApi, customComponentData);
  };

  redirectToNotifiction(eventId, msg) {
    let workflowName = msg.split(":")[1].trim().split(" ")[0];
    if (msg.toLowerCase().includes("workflow completed")) {
      let url = this.router.createUrlTree(['/Workflow', eventId, workflowName]);
      window.open(url.toString(), '_blank');
    } else {
      let url = this.router.createUrlTree(['/Workflow', workflowName]);
      window.open(url.toString(), '_blank');
    }
  }

  redirectTo(url) {
    window.location.href = url;
  }

  getAuthDetailsList() {
    return this.http.get(this.componentResourceUri + this.getAuthDetails);
  }
}
